import { cn } from "@ds/lib/utils";

/**
 * Table — primitive tabel untuk laporan/riwayat. Bersih & datar (Linear/shadcn,
 * bukan grid Bootstrap): tanpa kotak luar, tanpa zebra, tanpa header berwarna.
 * Pemisah = hairline horizontal saja; kolom uang kanan-align + tabular.
 */
export function Table({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="w-full overflow-x-auto">
      <table
        className={cn(
          "w-full border-collapse text-sm [&_tr]:border-b [&_tr]:border-border",
          className,
        )}
        {...props}
      />
    </div>
  );
}

export function THead({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return <thead className={cn("[&_tr]:border-border-strong", className)} {...props} />;
}

export function TBody({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody
      className={cn("[&_tr:last-child]:border-0", className)}
      {...props}
    />
  );
}

export function TR({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn(
        "transition-colors duration-100 hover:bg-faint/50",
        className,
      )}
      {...props}
    />
  );
}

export interface CellProps
  extends React.ThHTMLAttributes<HTMLTableCellElement> {
  /** Kanan-align + tabular untuk kolom angka/uang. */
  numeric?: boolean;
}

export function TH({ className, numeric, ...props }: CellProps) {
  return (
    <th
      scope="col"
      className={cn(
        "h-9 px-4 text-left align-middle text-[0.8125rem] font-medium text-muted",
        numeric && "text-right",
        className,
      )}
      {...props}
    />
  );
}

export function TD({ className, numeric, ...props }: CellProps) {
  return (
    <td
      className={cn(
        "px-4 py-3 align-middle text-ink",
        numeric && "text-right tabular-nums",
        className,
      )}
      {...props}
    />
  );
}
